export const LoadingElement = {
    types: {
        bodyText: {
            height: 8,
            borderRadius: 1,
        },
        displayText: {
            height: 24,
            borderRadius: 3,
        },
        sparkLine: {
            height: 4,
            borderRadius: 1,
        },
        avatarRect: {
            borderRadius: 3,
        },
        avatarCircle: {},
    },
};
//# sourceMappingURL=loading.js.map